var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2942 6.60786C3.63904 6.60786 3.10792 7.13898 3.10792 7.79414V20.7353C3.10792 21.3905 3.63904 21.9216 4.2942 21.9216H23.706C24.3611 21.9216 24.8922 21.3905 24.8922 20.7353V7.79414C24.8922 7.13898 24.3611 6.60786 23.706 6.60786H4.2942ZM1.16675 7.79414C1.16675 6.06689 2.56696 4.66669 4.2942 4.66669H23.706C25.4332 4.66669 26.8334 6.06689 26.8334 7.79414V20.7353C26.8334 22.4626 25.4332 23.8628 23.706 23.8628H4.2942C2.56696 23.8628 1.16675 22.4626 1.16675 20.7353V7.79414Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16675 12.1078C1.16675 11.5718 1.6013 11.1372 2.13734 11.1372H25.8628C26.3989 11.1372 26.8334 11.5718 26.8334 12.1078C26.8334 12.6439 26.3989 13.0784 25.8628 13.0784H2.13734C1.6013 13.0784 1.16675 12.6439 1.16675 12.1078Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.7b0f7a328e9191c22e423276a59e41a4.svg";
export { ForwardRef as ReactComponent };